import $ from 'jquery';
import axios from 'axios';
import { active, favouriteButtonSelector } from './constants';
import { tutorUrl, isTutorRoute, isTutorLessonRoute } from '../routes';

const favourite = 'favourite';
const favouriteMarkerSelector = '.tutor-lesson-card__favourite-marker';
const lessonFavouriteMarkerSelector = '.lesson-favourite-marker';
const infoCardVersionSelector = '.info-card-version';
const searchUrlParam = '?LessonListSearchForm%5Bsearch%5D=';
const infoCardInstructorSelector = '.info-card-instructor';
const lessonCardContainerSelector = '.tutor-lesson-card-container';
const lessonCardSelector = '.tutor-lesson-card';

const markFavouriteUrl = '/rest/tutor/user-lesson/set-is-favourite';
const rateUrl = '/rest/tutor/user-lesson/rate';

const getRatingStars = ratingRadioId => Number(ratingRadioId.charAt(ratingRadioId.length - 1));

const ratingSetHandler = function () {
    const tutorLessonId = Number($('.tutor-lesson-id').val());
    const rateMark = getRatingStars($(this).attr('id'));

    axios.post(rateUrl, { tutorLessonId, rateMark })
        .then(({data: {data}}) => {
            $('.tutor__rating span').html(data)
        })
        .catch(error => {
            if (error.response.status === 403) {
                window.location.href = '/auth/sign-in';

                return;
            }

            console.log(error);
        });
};

const markFavourite = e => {
    const $parent = $(e.target).closest(lessonCardSelector);
    const tutorLessonId = Number($parent.find('.tutor-lesson-id').val());

    const isFavourite = !$parent.hasClass(favourite);

    axios.post(markFavouriteUrl, { tutorLessonId, isFavourite })
        .catch((error) => {
            if (error.response.status === 403) {
                window.location.href = '/auth/sign-in';

                return;
            }

            console.log(error);
        });

    if (isFavourite) {
        $parent.addClass(favourite);

        return;
    }

    if ($(favouriteButtonSelector).hasClass(active)) {
        $parent.remove();

        return;
    }

    $parent.removeClass(favourite);
}

const markFavouriteLesson = e => {


    const $parent = $(lessonFavouriteMarkerSelector);
    const tutorLessonId = Number($('.tutor-lesson-id').val());
    const isFavourite = !$parent.hasClass(favourite);

    axios.post(markFavouriteUrl, { tutorLessonId, isFavourite })
        .catch((error) => {
            if (error.response.status === 403) {
                window.location.href = '/auth/sign-in';

                return;
            }

            console.log(error);
        });

    if (isFavourite) {
        $parent.addClass(favourite);

        return;
    }

    $parent.removeClass(favourite);
}

const goToVersion = e => {
    const version = $(e.target).text();

    if (!version) {
        return;
    }

    window.location.href = tutorUrl + searchUrlParam + version.trim().split(/\s+/)[0];
}

const goToInstructorPage = e => {
    const url = $(e.target).attr('data-url');

    if (!url) {
        return;
    }

    window.location.href = url;
}

export const tutorHandlers = () => {
    if (!isTutorRoute) {
        return;
    }

    $(lessonCardContainerSelector).on('click', lessonCardSelector, function () {
        window.location.href = $(this).data('url');
    });

    $(lessonCardContainerSelector).on('click', favouriteMarkerSelector, e => {
        e.stopPropagation();
        markFavourite(e);
    });

    $('.tutor-section__header-subtitle').on('click', function () {
        window.location.href = $(this).data('url');
    });

    if (!isTutorLessonRoute) {
        return;
    }

    $(lessonFavouriteMarkerSelector).on('click', markFavouriteLesson);

    $(infoCardVersionSelector).on('click', goToVersion);

    $(infoCardInstructorSelector).on('click', goToInstructorPage);

    $('.tutor__back').on('click', () => { window.location.href = tutorUrl; });

    let player;

    window.onYouTubePlayerAPIReady = function () {
        const videoId = $('#tutor-youtube-player').data('videoId');

        player = new YT.Player('tutor-youtube-player', { videoId });
    };

    $('.tutor__rating-stars input').on('input', ratingSetHandler);

    $('.tutor__recommendation-list-more').on('click', function () {
        $('.tutor__recommendation-rest-list').removeClass('hidden');
        $(this).addClass('hidden');
    });

    $('.timecode-link').on('click', function () {
        const second = $(this).data('second');

        if (!player) {
            return;
        }

        if (!player.seekTo) {
            return;
        }

        player.seekTo(second, true);
        $('html, body').animate({scrollTop: 0}, 500);
    });
};
